import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Snackbar,
  SnackbarContent,
  Paper,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";

// Apunta a DEV. El usuario cambiará esto a producción manualmente cuando corresponda.
const DevApiUrl = "https://prodapi.netizar.com/api";

function SubidaArchivoSimple() {
  const [uid, setUid] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [snack, setSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [colorFondo, setColorFondo] = useState("black");
  const [ultimoArchivoSubido, setUltimoArchivoSubido] = useState(null);

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0] || null);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setSnack(false);
  };

  const handleSubir = async () => {
    if (!uid.trim()) {
      setMensaje("Ingresá un UUID");
      setColorFondo("red");
      setSnack(true);
      return;
    }
    if (!archivo) {
      setMensaje("Seleccioná un archivo");
      setColorFondo("red");
      setSnack(true);
      return;
    }

    const data = new FormData();
    data.append("uid", uid.trim());
    data.append("archivo", archivo);

    try {
      setSubiendo(true);
      const response = await fetch(DevApiUrl + "/uploadfiles/uploadfiles", {
        method: "POST",
        body: data,
      });
      const result = await response.json();

      if (response.ok && result.status !== false) {
        setMensaje(result.message || "Archivo subido correctamente");
        setColorFondo("green");
        setUltimoArchivoSubido(uid.trim() + "-" + archivo.name);
      } else {
        setMensaje(result.message || "Error al subir el archivo");
        setColorFondo("red");
      }
      setSnack(true);
    } catch (error) {
      console.error("Error subiendo archivo:", error);
      setMensaje("Error al subir el archivo");
      setColorFondo("red");
      setSnack(true);
    } finally {
      setSubiendo(false);
    }
  };

  const handleVer = async () => {
    if (!ultimoArchivoSubido) return;
    try {
      const response = await fetch(
        DevApiUrl + "/uploadfiles/uploads/" + ultimoArchivoSubido
      );
      if (!response.ok) {
        setMensaje("No se encontró el archivo (" + response.status + ")");
        setColorFondo("red");
        setSnack(true);
        return;
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Error abriendo archivo:", error);
      setMensaje("Error al abrir el archivo");
      setColorFondo("red");
      setSnack(true);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 480 }}>
      <Paper sx={{ p: 3 }} variant="outlined">
        <Typography variant="h6" gutterBottom>
          Subida simple de comprobante (PROD)
        </Typography>

        <TextField
          label="UUID"
          fullWidth
          size="small"
          value={uid}
          onChange={(e) => setUid(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Button variant="outlined" component="label" sx={{ mb: 2 }}>
          {archivo ? archivo.name : "Seleccionar archivo"}
          <input hidden type="file" onChange={handleFileChange} />
        </Button>

        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
          <Button
            variant="contained"
            color="success"
            startIcon={<CloudUploadIcon />}
            onClick={handleSubir}
            disabled={subiendo}
          >
            {subiendo ? "Subiendo..." : "Subir"}
          </Button>

          {ultimoArchivoSubido && (
            <Button
              variant="outlined"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={handleVer}
            >
              Ver
            </Button>
          )}
        </Box>
      </Paper>

      <Snackbar
        open={snack}
        autoHideDuration={3000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <SnackbarContent
          style={{
            backgroundColor: colorFondo,
            color: "white",
            fontWeight: "bold",
          }}
          message={mensaje}
        />
      </Snackbar>
    </Box>
  );
}

export default SubidaArchivoSimple;
